import { FC, memo, useMemo } from 'react';
import { useController } from 'react-hook-form';

import FormControl from '@material-ui/core/FormControl';

import { HelperTxt } from '../helperTxt/HelperTxt';
import { TextEditor } from '../textEditor/TextEditor';
import { TextEditorProps } from '../textEditor/TextEditor.types';
import { FormInputProps } from './FormItems.types';

export const FormTextEditor: FC<FormInputProps & Partial<TextEditorProps>> = memo(
  ({ control, name, required, ...rest }) => {
    const {
      field,
      fieldState: { error },
    } = useController({
      name,
      control,
      defaultValue: '',
    });

    const helperText = useMemo(() => {
      if (error && rest.error !== false) {
        return error.message;
      }

      if (required) {
        return '*required';
      }

      return '';
    }, [error, rest.error, required]);

    return (
      <FormControl error={rest.error ?? !!error} fullWidth>
        <TextEditor {...rest} {...field} error={rest.error ?? !!error} />

        {helperText && <HelperTxt>{helperText}</HelperTxt>}
      </FormControl>
    );
  },
);
